<template>
    <div class="statistics-container">
            <ul class="card box">
                <li class="item" v-for="(value, key) in leftCount" :key="key">
                    <p class="card-title">{{value}}</p>
                    <p class="card-count">{{ taskNumData[key] || 0 }}</p>
                </li>
            </ul>
        <a-row :gutter="15" style="margin-bottom: 15px;">
            <a-col :span="8">
                <div class="box chart-box">
                    <div class="head">
                        <div class="text">采集来源分布</div>
                    </div>
                    <div id="barDataCountChart"></div>
                </div>
            </a-col>
            <a-col :span="16">
                <div class="box chart-box">
                    <div class="head">
                        <div class="text">采集趋势</div>
                        <div class="time-select-tab" :class="{ active: timeDuration === 3 }" @click="getTaskStatsDetailBySpiderId(3)">3日</div>
                        <div class="time-select-tab" :class="{ active: taskPieCountActive === 7 }" @click="getTaskStatsDetailBySpiderId(7)">7日</div>
                        <div class="time-select-tab" :class="{ active: taskPieCountActive === 30 }" @click="getTaskStatsDetailBySpiderId(30)">30日</div>
                    </div>
                    <div id="lineDataCountChart"></div>
                </div>
            </a-col>
        </a-row>

        <a-row :gutter="15">
            <a-col :span="8">
                <div class="box chart-box">
                    <div class="head">
                        <div class="text">数据下载分布</div>
                    </div>
                    <div id="barDataCountChart1"></div>
                </div>
            </a-col>
            <a-col :span="16">
                <div class="box chart-box">
                    <div class="head">
                        <div class="text">下载趋势</div>
                        <div class="time-select-tab" :class="{ active: timeDuration === 3 }" @click="getTaskStatsDetailBySpiderId(3)">3日</div>
                        <div class="time-select-tab" :class="{ active: timeDuration === 7 }" @click="getTaskStatsDetailBySpiderId(7)">7日</div>
                        <div class="time-select-tab" :class="{ active: timeDuration === 30 }" @click="getTaskStatsDetailBySpiderId(30)">30日</div>
                    </div>
                    <div id="lineDataCountChart1"></div>
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
  // import { getResulNumtById, getTaskNumById, taskStatsDetailBySpiderId } from '@/api/Site/Info'
  export default {
    data() {
      return {
        leftCount: {
          totalTaskNum: '采集总数',
          todayTaskNum: '有效采集数',
          totalResultNum: '无效采集数',
          todayAddResultNum: '数据下载次数',
          adsf: '数据下载量',
        },
        spiderStat: {},
        spiderStat30: {},
        timeDuration: 30,

        taskPieCountActive: 7,
        dutyStatusActive: 7,

        dualAxesPlot: null,
        piePlot: null,
        dualAxesPlot2: null,

        pieData: [],
        flowData: [
          { name: '2020-5-21', value: 21 },
          { name: '2020-5-24', value: 23 },
          { name: '2020-5-27', value: 25 },
          { name: '2020-5-30', value: 22 },
          { name: '2020-6-1', value: 23 },
          { name: '2020-6-4', value: 21 },
          { name: '2020-6-7', value: 25 }
        ],
        flowData1: [
          { label: '2020-5-21', value: 34 },
          { label: '2020-5-24', value: 31 },
          { label: '2020-5-27', value: 35 },
          { label: '2020-5-30', value: 32 },
          { label: '2020-6-1', value: 35 },
          { label: '2020-6-4', value: 37 },
          { label: '2020-6-7', value: 34 }
        ],
        taskNumData: {}
      }
    },
    computed: {

    },
    mounted() {
      this.$nextTick(() => {
        this.initLineDataCountChart('lineDataCountChart')
        this.initLineDataCountChart('lineDataCountChart1')
        this.initPieDataCountChart('barDataCountChart')
        this.initPieDataCountChart('barDataCountChart1')
      })
    },

    methods: {
      //顶部统计分析任务数
      async getTaskNumById() {
        const { code, extra } = await getTaskNumById({spiderId: this.$route.query.spiderId})
        if(code === 200) {
          this.taskNumData = Object.assign({},this.taskNumData, extra.data)
        }
      },

      //顶部统计结果任务数
      async getResulNumtById() {
        const { code, extra } = await getResulNumtById({spiderId: this.$route.query.spiderId})
        if(code === 200) {
          this.taskNumData = Object.assign({},this.taskNumData, extra.data)
        }
      },

      //调度任务统计详情
      async getTaskStatsDetailBySpiderId(day = 7) {
        this.taskPieCountActive = day
        const { code, extra } = await taskStatsDetailBySpiderId({spiderId: this.$route.query.spiderId, day})
        if(code === 200) {
          this.$nextTick(() => {
            this.initPieDataCountChart(extra.data)
          })
        }
      },

      initLineDataCountChart(id) {
        let chart = this.$echarts.init(document.getElementById(id))
        chart.setOption({
          tooltip: { trigger: 'axis' },
          legend: {
            top: 20
          },
          grid: {
            right: '1%',
            top: '20%',
            left: '5%',
            bottom: '20%'
          },
          xAxis: {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#E2E2E2',
                width: 2
              }
            },
            axisTick: { show: false },
            axisLabel: { color: '#666666', margin: 20 },
            splitLine: { color: '#EBEBEB', width: 1 },
            data: this.flowData.map(item => item.name)
          },
          yAxis: {
            type: 'value',
            axisLine: { show: false },
            axisLabel: { margin: 20 },
            axisTick: { show: false },
          },

          series: [
            {
              name: '新闻',
              type: 'line',
              itemStyle: { color: '#4683FF' },
              lineStyle: {width: 3 },
              data: this.flowData.map(item => item.value)
            },
            {
              name: '头条',
              type: 'line',
              itemStyle: { color: '#3DD598'},
              lineStyle: {width: 3 },
              data: this.flowData1.map(item => item.value)
            }
          ]
        })
        window.addEventListener('resize', () => {
          chart.resize()
        })
      },
      initPieDataCountChart(id) {
        let chart = this.$echarts.init(document.getElementById(id))
        chart.setOption({
          tooltip: { trigger: 'item' },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 105,
            bottom: 20,
            itemWidth: 12,
            itemHeight: 12,
            formatter: function (params) {
              return params
            }
          },
          series: [
            {
              type: 'pie',
              center: ['40%', '50%'],
              radius: ['50%', '70%'],
              color: ['#6D82FF', '#B56DFF', '#30B1FF', '#FFD959', '#FF9657', '#8DD879', '#3967C8'],
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: { show: false, },

              data: [
                {value: 3, name: '新闻'},
                {value: 3, name: '头条'},
                {value: 3, name: '推特'},
                {value: 3, name: '微博'},
                {value: 3, name: 'API'},
                {value: 4, name: '关键词'},
                {value: 5, name: 'Facebook'},
              ]
            }
          ]
        })
        window.addEventListener('resize', () => {
          chart.resize()
        })
      }
    }
  }
</script>


<style lang="less" scoped>
    .statistics-container {
        padding: 15px;
        width: 100%;
        .box{
            background: #fff;
            border-radius: 4px;
        }
        p{
            margin: 0;
        }

            .item{
                flex: 1;
                text-align: center;
                border-right: 1px solid #E2E2E2 ;
                .card-title{
                    font-size: 14px;
                    color: #999;
                }
                .card-count{
                    font-size: 36px;
                    font-weight: bold;
                    color: #333333;
                }
            }
            .card{
                padding: 25px 0;
                display: flex;
            }


        .head {
            height: 55px;
            border-bottom: 1px solid #e9e9e9;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .text {
                font-size: 18px;
                font-weight: 600;
                margin-right: auto;
            }

            .time-select-tab {
                font-size: 14px;
                cursor: pointer;
                width: 82px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background: #F5F6FA;
                border-radius: 4px;
                margin-left: 10px;
                &.active {
                    color: #fff;
                    background: #4683FF;
                }
            }
        }

        .chart-box{
            padding: 0 20px;
            #barDataCountChart, #lineDataCountChart, #lineDataCountChart1, #barDataCountChart1{
                height: 350px;
            }
        }
    }
</style>
